var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"custom-btn",attrs:{"color":"#2341F0","dark":!_vm.disabled,"rounded":"","block":_vm.block,"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }